import React, { useEffect, useRef, useState, useLocation } from 'react';
import EditServiceView from '../../views/PartnerView/EditServiceView';
import EditServiceDetails from '../../views/PartnerView/EditServiceDetails';
import { useParams } from 'react-router-dom';
import {useServiceContext} from '../../components/Context/ServiceContext';

const EditServiceComponent = () => {
        const {id, edit} = useParams();
    const didFetch = useRef(false);
    const [loading, setLoading] = useState(true);

    const {Updateservice, GetServiceByID} = useServiceContext();
    const fetchData = async () => {
        try {
             
            await GetServiceByID(id);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
         
        if (!didFetch.current) {
            fetchData();
            didFetch.current = true;
        }
    });
    
    return (
    <div>
    {/* {loading && <div>Loading...</div>}*/}
     {!loading  &&  edit === "false" && Updateservice!=null && <EditServiceDetails />}
     {!loading  &&  edit === "true" && Updateservice!=null && <EditServiceView  />}
    </div>
    // <div>
    //     {edit == "true" && <EditServiceView />}
    //     {edit == "false" && <EditServiceDetails  />}
    // </div>
    );
   
};

export default EditServiceComponent;
